export const PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON = 'primary-business-location-contact-person';
export const PRIMARY_BUSINESS_ADDRESS = 'primary-business-address';
export const ADDITIONAL_BUSINESS_LOCATION = 'additional-business-location';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const TDC_APPLICATION = [
    {
        sectionID: PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON,
        sectionName: 'Primary Business Location Contact Person Details',
        fieldList: [
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text'
            },
            {
                id: 'office-tel-number',
                label: 'Office Tel Number',
                type: 'text'
            },
            {
                id: 'mobile-number',
                label: 'Mobile Number',
                type: 'text'
            }
        ]
    },
    {
        sectionID: PRIMARY_BUSINESS_ADDRESS,
        sectionName: 'Primary Business Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level-optional',
                label: 'Floor Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ADDITIONAL_BUSINESS_LOCATION,
        sectionName: 'Additional Business Location',
        fieldList: [
            {
                id: 'additional-business-location-list',
                label: '',
                type: 'table',
                subFields: [
                    {
                        id: 'no',
                        header: 'No.',
                        type: 'text'
                    },
                    {
                        id: 'branch-name',
                        header: 'Branch Name',
                        type: 'text'
                    },
                    {
                        id: 'designation',
                        header: 'Designation',
                        type: 'text'
                    },
                    {
                        id: 'branch-contact-person',
                        header: 'Branch Contact Person',
                        type: 'text'
                    },
                    {
                        id: 'office-tel-number',
                        header: 'Office Tel Number',
                        type: 'text'
                    },
                    {
                        id: 'mobile-number',
                        header: 'Mobile Number',
                        type: 'text'
                    },
                    {
                        id: 'email',
                        header: 'Email',
                        type: 'text'
                    },
                    {
                        id: 'address',
                        header: 'Address',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
